'use client';

import { createContext, useContext } from 'react';

export type AuthNavigation = {
  showLogin: () => void;
  showRegister: () => void;
  showPasswordReset: () => void;
  /** The account was created: swaps the form for the confirmation. */
  showRegistered: () => void;
  /** The customer signed in. */
  signedIn: () => void;
  close: () => void;
};

const AuthNavigationContext = createContext<AuthNavigation | null>(null);

export const AuthNavigationProvider = AuthNavigationContext.Provider;

/** Moves between the views of the one authentication dialog (login, registration, password reset). */
export function useAuthNavigation() {
  const navigation = useContext(AuthNavigationContext);
  if (!navigation) throw new Error('useAuthNavigation must be used inside the AuthDialog');
  return navigation;
}
